import React, { FC, ChangeEvent } from 'react';
import { PropertyTypeRadioButtonWrapper } from '../../../search/common/Dropdown.styles';
import { useDispatch, useSelector } from 'react-redux';
import { FilterOptions } from '../../../reducers/filters.types';
import { updateFilter, transportTypeSelector } from '../../../reducers/filters';
import { FiltersLabel } from '../../../search/FiltersModal/Filters.styles';
import { PropertyTypeRadio } from './SearchInitiationMobile.styles';
import { Radio } from '@blueprint/ui';

type TransportTypeRadioOptions = {
    options: FilterOptions;
    onTransportTypeChange: (evt: ChangeEvent<HTMLInputElement>) => void;
    transportType: string | string[];
};

const TransportTypeRadioButtons: FC<TransportTypeRadioOptions> = ({
    options,
    onTransportTypeChange,
    transportType
}) => {
    return (
        <>
            {options?.map((option) => {
                const { label, value } = option;

                const idKey = `mobile_subheader_property_type_option${
                    value ? `_${value}` : '_all'
                }`;

                const hasSelectedThisTransportType = transportType === value;

                return (
                    <PropertyTypeRadio key={`${value}-${label}`}>
                        <Radio
                            key={`${value}-${label}`}
                            id={idKey}
                            data-testid={value}
                            name="transportTypeOption"
                            label={label}
                            value={value}
                            checked={hasSelectedThisTransportType}
                            onChange={onTransportTypeChange}
                        />
                    </PropertyTypeRadio>
                );
            })}
        </>
    );
};

export const SelectTransportMode: FC = () => {
    const reduxDispatch = useDispatch();

    const {
        selectedValue: transportTypeSelectedValue,
        options: transportTypeOptions
    } = useSelector(transportTypeSelector);

    const onTransportTypeChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(updateFilter('transportType', evt.currentTarget.value));
    };

    const transportTypeLabel = 'Transport mode';

    return (
        <>
            <FiltersLabel htmlFor="modal-price-filter">
                {transportTypeLabel}
            </FiltersLabel>
            <PropertyTypeRadioButtonWrapper>
                <TransportTypeRadioButtons
                    onTransportTypeChange={onTransportTypeChange}
                    transportType={transportTypeSelectedValue}
                    options={transportTypeOptions}
                    data-testid="mobile-select-transport-type-dropdown"
                />
            </PropertyTypeRadioButtonWrapper>
        </>
    );
};
